import { Box } from '@cmpsr/components';

export interface HeroVideoProps {
  src: string;
  children?: React.ReactNode;
}

export function HeroVideo({ src, children }: HeroVideoProps) {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      width="100%"
      height="100%"
      zIndex={0}
      overflow="hidden"
    >
      <video
        src={src}
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      {/* Overlay */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        style={{
          opacity: 0.7,
          backgroundImage: 'linear-gradient(to bottom, #000, #000)',
          marginTop: 0,
          marginBottom: 0,
        }}
      />
      {/* Children overlayed above video and overlay */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex={1}
        p={4}
        textAlign="center"
      >
        {children}
      </Box>
    </Box>
  );
}
